import React, { useState, useEffect } from 'react';
import { X, Shield, Cookie, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('carelio_cookie_consent');
    if (!consent) {
      // Show banner after 1 second
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('carelio_cookie_consent', JSON.stringify({
      necessary: true,
      analytics: true,
      functional: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('carelio_cookie_consent', JSON.stringify({
      necessary: true,
      analytics: false,
      functional: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-4 border-primary shadow-2xl p-6 animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-primary-50 rounded-full flex-shrink-0">
            <Shield className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-primary-900 mb-2 flex items-center gap-2">
              <Cookie className="w-5 h-5" />
              Respect de votre vie privée
            </h3>
            <p className="text-sm text-slate-600 mb-4 leading-relaxed">
              <strong>Carelio</strong> respecte le <strong>RGPD</strong> et la réglementation française sur les données de santé. 
              Nous utilisons des cookies essentiels au fonctionnement de la plateforme et, avec votre consentement, 
              des cookies d'analyse pour améliorer votre expérience. Vos <strong>données médicales sont hébergées en France</strong> 
              par un hébergeur sécurisé.
            </p>
            <div className="flex flex-wrap gap-3">
              <Button
                data-testid="accept-all-cookies"
                onClick={acceptAll}
                size="sm"
              >
                Tout accepter
              </Button>
              <Button
                data-testid="accept-necessary-cookies"
                onClick={acceptNecessary}
                variant="outline"
                size="sm"
              >
                Cookies essentiels uniquement
              </Button>
              <a
                href="/confidentialite"
                className="text-sm text-primary hover:underline flex items-center gap-1 px-4 py-2"
              >
                <Lock className="w-4 h-4" />
                Politique de confidentialité
              </a>
            </div>
          </div>
          <button
            onClick={acceptNecessary}
            className="text-slate-400 hover:text-slate-600 flex-shrink-0"
            aria-label="Fermer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
